/*  ========================================================================
    # Main JavaScript
    ========================================================================  */

import PageStatus from './scripts/page-status';
import LanguageSwitcher from './scripts/language-switcher';
import MenuToggle from './scripts/menu-toggle';
import RequestModal from './scripts/request-modal';
import ProductHeroAnimation from './scripts/product-hero-animation';
import Accordions from './scripts/accordions';
import SeparatorAnimation from './scripts/separator-animation';
import ContactRequest from './scripts/contact-request';
import NewsletterSubscription from './scripts/newsletter-subscription';

const scripts = [
  PageStatus,
  LanguageSwitcher,
  MenuToggle,
  RequestModal,
  ProductHeroAnimation,
  Accordions,
  SeparatorAnimation,
  ContactRequest,
  NewsletterSubscription
];

document.addEventListener('DOMContentLoaded', () => {
  if (scripts.length > 0 && scripts !== undefined) {
    scripts.forEach(script => {
      script.init();
    });
  }
});
